import { Chip } from "../primitives/index.ts";
import { useT } from "../i18n/I18nProvider.tsx";

/** "External · Parceiro Ltda" pill for members from another organization. */
export function ExternalBadge({ organization }: { organization?: string }) {
  const t = useT();
  return <Chip label={organization === undefined ? t("guest.badge") : t("guest.badgeOrg", { org: organization })} tone="external" icon="external" testID="external-badge" />;
}

/** "Agent" pill next to agent names. */
export function AgentBadge() {
  const t = useT();
  return <Chip label={t("agent.badge")} tone="agent" icon="agent" testID="agent-badge" />;
}

/** "App" pill next to messages an integration posted (incoming webhook, channel reminder), like Slack's APP tag. */
export function AppBadge() {
  const t = useT();
  return <Chip label={t("message.appBadge")} testID="app-badge" />;
}
